var React = require('react');

function IconCircleWarning (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0 0 114.6 0 256s114.6 256 256 256zm0-384c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm32 224c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32z"}));
}

IconCircleWarning.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = IconCircleWarning;

IconCircleWarning.default = IconCircleWarning;
